import {ReviewsError} from './ReviewsError.js'

export class RatingError extends ReviewsError {}
